import WebsiteBehaviors from "../website-behaviors/index.js";
import {waitUntil} from "../utils/async.js";
import {triggerEvent} from "../utils/document.js";

class Logos extends WebsiteBehaviors {
	identifier() {
		return "Logos";
	}

	// @ts-expect-error TS(7006) FIXME: Parameter 'location' implicitly has an 'any' type.
	static test(location) {
		return (location.host === "app.logos.com");
	}

	async init() {
		await super.init();

		// @ts-expect-error TS(7034) FIXME: Variable 'results' implicitly has type 'any[]' in ... Remove this comment to see the full error message
		let results = [];
		const condition = () => {
			const nodeList = document.querySelectorAll(".tab-dropdown-wrapper button[class^=item]");

			results = Array.from(nodeList)
				.filter(e => e.textContent === "Enable compatibility mode");

			return results.length > 0;
		};

		try {
			await waitUntil(condition);
			if (results.length > 0)
			// @ts-expect-error TS(7005) FIXME: Variable 'results' implicitly has an 'any[]' type.
				triggerEvent(document, results[0], "click");
		} catch (e) {
			// Never found the button. Probably already in "compatibility mode".
		}
	}
}

export default Logos;
